import { schema } from 'normalizr';
import { MODELS } from '../types';

export const productSchema = new schema.Entity(MODELS.PRODUCTS, {});
